import React from 'react';
import { Route } from 'react-router-dom';
import { CssBaseline } from '@material-ui/core';
import { ThemeProvider } from '@material-ui/core/styles';
import { LoginHandler, AuthorizeRoute } from './components/auth';
import { DashboardView, LoginView } from './views';
import LogoutView from './views/LogoutView';
import theme from './theme';

export default function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Route exact path="/" render={() => <LoginHandler action="login" />} />
      <Route path="/login" render={() => <LoginHandler action="login" />} />
      <Route path="/login-callback" render={() => <LoginHandler action="login-callback" />} />
      <Route path="/logout" render={() => <LoginHandler action="logout" />} />
      <Route path="/logout-callback" render={() => <LoginHandler action="logout-callback" />} />
      <Route path="/login-oidc" component={LoginView} />
      <Route path="/logout-oidc" component={LogoutView} />
      <AuthorizeRoute path="/dashboard" component={DashboardView} />
    </ThemeProvider>
  );
};
